export default "__VITE_ASSET__3$CvYX2K__"